<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
          <div class="form-group row">
              <!-- <label class="col-form-label col-2"><span translate="KOMITENTTELEFON.VRSTATELEFONA.SINGULAR"></span></label> -->
              <div class="col-md-12">
                  <!-- <yt-fw-dropdown
                  [ModelName]="'vrstatelefona'"
                  [GetName]="'get'"
                  [ModelProperty]="'Naziv'"
                  [OrderBy]="'Naziv'"
                  [AllowAddNew]='true'
                  [Required]='true'
                  [Disabled]='false'
                  formControlName="VrstaTelefonaID"
                  name="cmbVrstaTelefona"
                  [Type]="ID"
                  [ngClass]="{'is-invalid': submitted && fc.VrstaTelefonaID.invalid}"
                  [Label]="'KOMITENTTELEFON.VRSTATELEFONA.SINGULAR'">
                </yt-fw-dropdown> -->
                <yt-dropdown-picklist
                [ModelName]="'vrstatelefona'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]="false"
                formControlName="VrstaTelefonaID"
                [Label]="'KOMITENTTELEFON.VRSTATELEFONA.SINGULAR'"
                >
                </yt-dropdown-picklist>
                <div class="form-error" *ngIf="submitted && fc.VrstaTelefonaID.invalid">
                    <span *ngFor="let validation of errorMessages.VrstaTelefonaID">
                      <span class="error-message" *ngIf="fc.VrstaTelefonaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
              </div>
          </div>
        <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="KOMITENTTELEFON.BROJ.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtBroj"
                formControlName="Broj"
                [MaxLength]="50"
                [ngClass]="{'is-invalid': submitted && fc.Broj.invalid}"
                [Label]="'KOMITENTTELEFON.BROJ.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Broj.invalid">
                    <span *ngFor="let validation of errorMessages.Broj">
                      <span class="error-message" *ngIf="fc.Broj.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>
          </div>
          <div class="form-group row">
              <!-- <label class="col-form-label col-2"><span translate="KOMITENTTELEFON.LOKAL.SINGULAR"></span></label> -->
              <div class="col-md-12">
                <yt-input
                  [Type]="'text'"
                  name="txtLokal"
                  formControlName="Lokal"
                  [MaxLength]="4"
                  [ngClass]="{'is-invalid': submitted && fc.Lokal.invalid}"
                  [Label]="'KOMITENTTELEFON.LOKAL.SINGULAR'">
                </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.Lokal.invalid">
                      <span *ngFor="let validation of errorMessages.Lokal">
                        <span class="error-message" *ngIf="fc.Lokal.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                  </div>
              </div>
            </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="KOMITENTTELEFON.GLAVNI.SINGULAR"></span></label>
          <div class="col-md-1">
            <input
              style="width: 20px;"
              type="checkbox"
              name="txtGlavni"
              class="form-control"
              formControlName="Glavni"
              autocomplete="off"
              >
          </div> -->
          <div class="col-md-12">
              <div class="form-check" style="padding-top: 22px">
                <input
                class="form-check-input" 
                type="checkbox"
                formControlName="Glavni"
                id="chkGlavni"
                >
                <label class="form-check-label" for="chkGlavni"><span translate="KOMITENTTELEFON.GLAVNI.SINGULAR"></span></label>
              </div>
            </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="KOMITENTTELEFON.SVOJINA.SINGULAR"></span></label> -->
          <div class="col-md-12">
              <!-- <yt-fw-dropdown
              [ModelName]="'svojina'"
              [GetName]="'get'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]='true'
              [Required]='true'
              [Disabled]='false'
              formControlName="SvojinaID"
              name="cmbSvojina"
              [Type]="ID"
              [ngClass]="{'is-invalid': submitted && fc.SvojinaID.invalid}"
              [Label]="'KOMITENTTELEFON.SVOJINA.SINGULAR'">
            </yt-fw-dropdown> -->
            <yt-dropdown-picklist
                    [ModelName]="'svojina'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="false"
                    formControlName="SvojinaID"
                    [Label]="'KOMITENTTELEFON.SVOJINA.SINGULAR'"
                    >
                    </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.SvojinaID.invalid">
                <span *ngFor="let validation of errorMessages.SvojinaID">
                  <span class="error-message" *ngIf="fc.SvojinaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="KOMITENTTELEFON.OPIS.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtOpis"
              formControlName="Opis"
              [MaxLength]="100"
              [Label]="'KOMITENTTELEFON.OPIS.SINGULAR'">
            </yt-input>
          </div>
        </div> 
      </div>
    </div>
  </div>
</form>
